<template>
  <div class="blog-page" v-if="blog">
    <navbar /> <!-- tu componente navbar -->

    <section
      class="banner-full"
      :style="{ backgroundImage: 'url(' + blog.imagen_url + ')' }"
      role="img"
      aria-label="Imagen destacada del blog"
    ></section>

    <div class="page-layout">
      <aside class="side-column left"></aside>

      <main class="main-content">
        <header class="page-header">
          <h1 class="fancy-title">{{ blog.titulo }}</h1>
          <div class="meta">
            <span>Por <strong>{{ blog.autor }}</strong></span>
            <span class="date">• {{ formatDate(blog.fecha_publicacion) }}</span>
          </div>
        </header>

        <article class="content-area" v-html="blog.contenido"></article>
      </main>

      <aside class="side-column right">
        <div class="card social-card">
          <h2>Redes Sociales</h2>
          <ul class="social-links">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener">
                <svg class="icon" viewBox="0 0 24 24" fill="#3b5998" xmlns="http://www.w3.org/2000/svg"><path d="M22.675 0H1.325C.593 0 0 .593 0 1.326v21.348C0 23.408.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.463.099 2.794.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.313h3.588l-.467 3.622h-3.121V24h6.116c.73 0 1.324-.592 1.324-1.326V1.326C24 .593 23.408 0 22.675 0z"/></svg>
                Facebook
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" rel="noopener">
                <svg class="icon" viewBox="0 0 24 24" fill="#1da1f2" xmlns="http://www.w3.org/2000/svg"><path d="M24 4.557a9.83 9.83 0 0 1-2.828.775 4.933 4.933 0 0 0 2.165-2.724 9.868 9.868 0 0 1-3.127 1.196 4.918 4.918 0 0 0-8.38 4.482A13.949 13.949 0 0 1 1.671 3.149 4.916 4.916 0 0 0 3.195 9.722 4.9 4.9 0 0 1 .96 9.1v.062a4.917 4.917 0 0 0 3.946 4.814 4.904 4.904 0 0 1-2.212.084 4.92 4.92 0 0 0 4.59 3.417 9.867 9.867 0 0 1-6.102 2.105c-.396 0-.788-.023-1.174-.067a13.944 13.944 0 0 0 7.557 2.212c9.054 0 14-7.496 14-13.986 0-.213-.005-.425-.014-.636A9.936 9.936 0 0 0 24 4.557z"/></svg>
                Twitter
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener">
                <svg class="icon" viewBox="0 0 24 24" fill="#e4405f" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.206.058 2.003.248 2.478.415a4.918 4.918 0 0 1 1.675 1.008 4.918 4.918 0 0 1 1.008 1.675c.167.475.357 1.272.415 2.478.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.058 1.206-.248 2.003-.415 2.478a4.918 4.918 0 0 1-1.008 1.675 4.918 4.918 0 0 1-1.675 1.008c-.475.167-1.272.357-2.478.415-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.206-.058-2.003-.248-2.478-.415a4.918 4.918 0 0 1-1.675-1.008 4.918 4.918 0 0 1-1.008-1.675c-.167-.475-.357-1.272-.415-2.478C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.058-1.206.248-2.003.415-2.478a4.918 4.918 0 0 1 1.008-1.675 4.918 4.918 0 0 1 1.675-1.008c.475-.167 1.272-.357 2.478-.415C8.416 2.175 8.796 2.163 12 2.163zM12 0C8.741 0 8.332.015 7.052.072 5.773.128 4.678.315 3.758.676a7.17 7.17 0 0 0-2.588 1.525A7.17 7.17 0 0 0 .676 4.79c-.361.92-.548 2.015-.604 3.294C.015 8.332 0 8.741 0 12c0 3.259.015 3.668.072 4.948.056 1.279.243 2.374.604 3.294a7.17 7.17 0 0 0 1.494 2.588 7.17 7.17 0 0 0 2.588 1.525c.92.361 2.015.548 3.294.604 1.28.057 1.689.072 4.948.072s3.668-.015 4.948-.072c1.279-.056 2.374-.243 3.294-.604a7.17 7.17 0 0 0 2.588-1.525 7.17 7.17 0 0 0 1.494-2.588c.361-.92.548-2.015.604-3.294.057-1.28.072-1.689.072-4.948s-.015-3.668-.072-4.948c-.056-1.279-.243-2.374-.604-3.294a7.17 7.17 0 0 0-1.494-2.588 7.17 7.17 0 0 0-2.588-1.525c-.92-.361-2.015-.548-3.294-.604C15.668.015 15.259 0 12 0z"/><path d="M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
                Instagram
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener">
                <svg class="icon" viewBox="0 0 24 24" fill="#0077b5" xmlns="http://www.w3.org/2000/svg"><path d="M20.447 20.452h-3.554v-5.569c0-1.327-.025-3.036-1.849-3.036-1.849 0-2.132 1.445-2.132 2.939v5.666H9.359V9h3.414v1.561h.049c.476-.9 1.635-1.849 3.366-1.849 3.598 0 4.264 2.368 4.264 5.451v6.289zM5.337 7.433a2.07 2.07 0 1 1 0-4.139 2.07 2.07 0 0 1 0 4.139zm1.777 13.019H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.73v20.538C0 23.224.792 24 1.771 24h20.451C23.2 24 24 23.224 24 22.269V1.73C24 .774 23.2 0 22.225 0z"/></svg>
                LinkedIn
              </a>
            </li>
          </ul>
        </div>

        <div class="card recommended-card">
          <h2>Blogs Recomendados</h2>
          <ul class="recommended-list">
            <li v-for="(rec, i) in recommendedBlogs" :key="i" class="recommended-item">
              <a :href="rec.url" target="_blank" rel="noopener" class="recommended-link">
                <img :src="rec.image" alt="" class="recommended-image" />
                <div class="recommended-text">
                  <h3>{{ rec.title }}</h3>
                  <p>{{ rec.summary }}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import axios from 'axios';

export default {
  components: { Navbar, },
  data() {
    return {
      blog: null,
      recommendedBlogs: [
        { 
          title: "Cómo elegir el mejor equipo de senderismo",
          url: "#",
          image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=80&q=80",
          summary: "Tips para elegir equipo resistente y cómodo para tus aventuras."
        },
        {
          title: "10 consejos para preparar tu mochila",
          url: "#",
          image: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=80&q=80",
          summary: "Guía práctica para empacar de forma eficiente y ligera."
        },
        {
          title: "Rutas de montaña para principiantes",
          url: "#",
          image: "https://images.unsplash.com/photo-1500534623283-312aade485b7?auto=format&fit=crop&w=80&q=80",
          summary: "Explora rutas fáciles y seguras para comenzar en el senderismo."
        },
        {
          title: "Qué llevar en una caminata larga",
          url: "#",
          image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=80&q=80",
          summary: "Elementos imprescindibles para no quedarte sin nada."
        },
      ]
    };
  },
  methods: {
  formatDate(date) {
    if (!date) return '';
    // Si el backend devuelve "2025-08-21 10:00:00", lo convertimos a ISO válido
    const isoDate = date.includes(' ') ? date.replace(' ', 'T') : date;
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(isoDate).toLocaleDateString('es-MX', options);
  }
},
  created() {
    const slug = this.$route.params.slug;
    axios.get(`http://localhost:3000/api/blogs/${slug}`)
      .then(res => this.blog = res.data);
  }
};
</script>

<style scoped>
/* Reset y tipografía base */
.blog-page {
  font-family: 'Open Sans', sans-serif;
  color: #333;
  background-color: #fff;
  min-height: 100vh;
}

/* Navbar fija: ajusta si tu navbar ya es fija */
navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

/* Imagen banner full width */
.banner-full {
  width: 100vw;
  height: 60vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 56px; /* altura navbar */
  position: relative;
}

/* Layout 3 columnas */
.page-layout {
  display: grid;
  grid-template-columns: 1fr minmax(0, 900px) 320px; /* derecha 320px para las tarjetas */
  gap: 2rem;
  padding: 3rem 1rem 4rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}

/* Columna izquierda vacía */
.side-column.left {
  display: block;
}

/* Columna derecha con tarjetas */
.side-column.right {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  font-size: 0.95rem;
  color: #444;
}

/* Tarjetas en columna derecha */
.card {
  background: #fafafa; /* fondo casi blanco, muy suave */
  border-radius: 12px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05); /* sombra muy sutil */
  padding: 1.5rem 1.8rem;
  transition: box-shadow 0.3s ease;
  font-family: 'Open Sans', sans-serif;
}

.card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); /* sombra suave al hover */
}

/* Títulos de las tarjetas */
.card h2 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 1.4rem;
  color: #222; /* Negro suave para títulos */
  border-bottom: 3px solid #bbb; /* línea gris muy suave */
  padding-bottom: 0.4rem;
  letter-spacing: 0.05em;
}

/* Redes Sociales */

.social-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.social-links li {
  margin-bottom: 1rem;
}

.social-links a {
  color: #556677; /* azul grisáceo sutil */
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: color 0.3s ease;
  font-size: 1.1rem;
  font-family: 'Open Sans', sans-serif;
}

.social-links a:hover {
  color: #334455; /* azul más oscuro pero aún suave */
  text-decoration: underline;
}

/* Íconos SVG para redes sociales */
.icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  filter: none; /* Quitar drop shadow para más limpieza */
}

/* Blogs recomendados */

.recommended-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.recommended-item {
  background: #fcfcfc; /* casi blanco */
  border-radius: 10px;
  box-shadow: 0 1px 5px rgba(0,0,0,0.04);
  transition: box-shadow 0.3s ease;
  font-family: 'Open Sans', sans-serif;
}

.recommended-item:hover {
  box-shadow: 0 4px 15px rgba(0,0,0,0.07);
}

.recommended-link {
  display: flex;
  text-decoration: none;
  color: #222; /* texto negro suave */
  padding: 0.8rem 1rem;
  align-items: center;
  gap: 1rem;
  font-family: 'Open Sans', sans-serif;
}

.recommended-image {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: 0 3px 7px rgba(0,0,0,0.1);
}

.recommended-text h3 {
  margin: 0 0 0.3rem;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: 'Open Sans', sans-serif;
}

.recommended-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #555;
  font-family: 'Open Sans', sans-serif;
}

/* Contenido principal */
.main-content {
  color: #444;
  line-height: 1.7;
  font-size: 1.125rem;
  overflow-wrap: break-word;
  font-family: 'Open Sans', sans-serif;
}

/* Header del blog */
/* Quitar degradado y color azul, poner negro */
.fancy-title {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 3rem;
  margin: 0 0 0.3rem;
  color: #222; /* negro suave */
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: unset;
  filter: none;
}

.page-header {
  margin-bottom: 2rem;
  padding-bottom: 0.5rem;
  text-align: center;
}

/* Meta información */
.meta {
  color: #666;
  font-style: italic;
  font-size: 1rem;
  font-family: 'Open Sans', sans-serif;
}

.meta .date {
  margin-left: 0.5rem;
  color: #999;
  font-family: 'Open Sans', sans-serif;
}

/* Contenido */
.content-area h2, .content-area h3 {
  border-left: 4px solid #bbb; /* gris muy suave */
  padding-left: 0.8rem;
  color: #444; /* gris oscuro para subtítulos */
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}


.content-area blockquote {
  border-left: 4px solid #ddd; /* gris clarito */
  color: #555;
  font-style: italic;
  margin: 2rem 0;
  padding-left: 1rem;
  background-color: #fafafa; /* muy suave */
  border-radius: 4px;
  font-family: 'Open Sans', sans-serif;
}

.content-area a {
  color: #6688aa; /* azul muy suave */
  text-decoration: underline;
  transition: color 0.3s ease;
  font-family: 'Open Sans', sans-serif;
}

.content-area a:hover {
  color: #446688; /* azul algo más oscuro */
  text-decoration: none;
}

/* Responsive */
@media (max-width: 1024px) {
  .page-layout {
    grid-template-columns: 1rem minmax(0, 90vw);
    gap: 1rem;
    padding: 2rem 0.5rem 3rem;
  }
  .side-column.right {
    display: none;
  }
}

@media (max-width: 600px) {
  .banner-full {
    height: 220px;
    margin-top: 48px;
  }
  .page-header h1, .fancy-title {
    font-size: 2rem;
  }
}

.content-area img {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 100% !important;
  height: auto !important;
}

/* Si está dentro de un párrafo, también centrarlo */
.content-area p {
  display: flex;
  justify-content: center;
}

</style>
